/**
 * KROQ — Index des races : bascule A-Z / catégories, recherche et filtres.
 *
 * Amélioration progressive. Sans JavaScript, la page reste utilisable : les
 * sections alphabétiques sont rendues par Liquid et visibles, seuls les
 * contrôles restent masqués (ils sont révélés ici).
 *
 * Aucune dépendance, aucune requête réseau : les ~30 races sont déjà dans le
 * DOM. Le coût reste linéaire, ce qui tient largement au-delà de 100 races.
 */
(function () {
  'use strict';

  var root = document.querySelector('[data-breed-index]');
  if (!root) return;

  var cards = Array.prototype.slice.call(root.querySelectorAll('[data-breed-card]'));
  var letterSections = Array.prototype.slice.call(root.querySelectorAll('[data-letter-section]'));
  var alphabetNav = root.querySelector('[data-alphabet]');
  var searchInput = root.querySelector('[data-breed-search]');
  var emptyState = root.querySelector('[data-breed-empty]');
  var countLive = root.querySelector('[data-breed-count]');
  var viewButtons = Array.prototype.slice.call(root.querySelectorAll('[data-view-switch]'));
  var chips = Array.prototype.slice.call(root.querySelectorAll('[data-facet]'));
  var controls = root.querySelector('[data-breed-controls]');

  var state = { view: 'alpha', query: '', facets: {} };

  if (controls) controls.hidden = false;

  /** Sans accents, minuscules : « Bichon Frisé » se trouve en tapant « frise ». */
  function fold(value) {
    return (value || '')
      .toString()
      .normalize('NFD')
      .replace(/[̀-ͯ]/g, '')
      .toLowerCase()
      .trim();
  }

  /**
   * « Moyenne à grande » appartient a la fois a Moyenne et a Grande. On ne
   * force donc pas une valeur intermediaire dans une seule categorie.
   */
  function tokens(value) {
    return fold(value)
      .split(/\s+a\s+|\s*\/\s*|\s*,\s*/)
      .map(function (part) { return part.trim(); })
      .filter(Boolean);
  }

  function matchesFacets(card) {
    for (var family in state.facets) {
      if (!Object.prototype.hasOwnProperty.call(state.facets, family)) continue;
      var wanted = state.facets[family];
      if (!wanted) continue;
      var got = tokens(card.getAttribute('data-' + family));
      if (got.indexOf(fold(wanted)) === -1) return false;
    }
    return true;
  }

  function matchesQuery(card) {
    if (!state.query) return true;
    return fold(card.getAttribute('data-name')).indexOf(state.query) !== -1;
  }

  function apply() {
    var visible = 0;

    cards.forEach(function (card) {
      var show = matchesQuery(card) && matchesFacets(card);
      card.hidden = !show;
      if (show) visible += 1;
    });

    // Une lettre dont toutes les races sont masquees n'a plus lieu d'etre.
    letterSections.forEach(function (section) {
      var anyVisible = section.querySelector('[data-breed-card]:not([hidden])');
      section.hidden = !anyVisible;
    });

    var filtering = state.query !== '' || hasActiveFacet();
    if (alphabetNav) alphabetNav.hidden = filtering;

    if (emptyState) emptyState.hidden = visible !== 0;
    if (countLive) {
      countLive.textContent = countLive.getAttribute('data-template').replace('%count%', visible);
    }
  }

  function hasActiveFacet() {
    for (var family in state.facets) {
      if (state.facets[family]) return true;
    }
    return false;
  }

  function setView(view) {
    state.view = view;
    root.setAttribute('data-current-view', view);
    viewButtons.forEach(function (button) {
      var active = button.getAttribute('data-view-switch') === view;
      button.setAttribute('aria-pressed', active ? 'true' : 'false');
    });
    if (view === 'alpha') {
      // Revenir en A-Z remet les facettes a zero : on ne masque pas des
      // races sans que le controle correspondant soit visible.
      state.facets = {};
      chips.forEach(function (chip) { chip.setAttribute('aria-pressed', 'false'); });
    }
    apply();
  }

  viewButtons.forEach(function (button) {
    button.addEventListener('click', function () {
      setView(button.getAttribute('data-view-switch'));
    });
  });

  chips.forEach(function (chip) {
    chip.addEventListener('click', function () {
      var family = chip.getAttribute('data-facet');
      var value = chip.getAttribute('data-value');
      var already = state.facets[family] === value;

      state.facets[family] = already ? null : value;

      chips.forEach(function (other) {
        if (other.getAttribute('data-facet') !== family) return;
        var on = !already && other === chip;
        other.setAttribute('aria-pressed', on ? 'true' : 'false');
      });

      apply();
      syncUrl();
    });
  });

  if (searchInput) {
    searchInput.addEventListener('input', function () {
      state.query = fold(searchInput.value);
      apply();
    });
  }

  /**
   * Les filtres se refletent dans l'URL pour que le lien reste partageable,
   * via replaceState : aucune entree d'historique, aucune page indexable
   * supplementaire. Le canonical reste celui de la page.
   */
  function syncUrl() {
    if (!window.history || !window.history.replaceState) return;
    var params = new URLSearchParams();
    Object.keys(state.facets).forEach(function (family) {
      if (state.facets[family]) params.set(family, state.facets[family]);
    });
    var qs = params.toString();
    window.history.replaceState(null, '', qs ? '?' + qs : window.location.pathname);
  }

  /** Rejoue les filtres presents dans l'URL au chargement. */
  function restoreFromUrl() {
    var params = new URLSearchParams(window.location.search);
    var restored = false;
    chips.forEach(function (chip) {
      var family = chip.getAttribute('data-facet');
      var value = chip.getAttribute('data-value');
      if (fold(params.get(family)) === fold(value)) {
        state.facets[family] = value;
        chip.setAttribute('aria-pressed', 'true');
        restored = true;
      }
    });
    if (restored) setView('facets');
  }

  restoreFromUrl();
  apply();
})();
